export const articles = [
  {
    id: 1,
    title: "Javascript higher order functions",
    description: "an article on how to use javascript higher order functions",
    img: require("./images/pic1.webp"),
    link: "https://abelwanyonyi.hashnode.dev",
  },
  {
    id: 2,
    title: "Javascript Functions",
    description: "Using javascript functions",
    img: require("./images/pic4.webp"),
    link: "https://abelwanyonyi.hashnode.dev",
  },
  {
    id: 3,
    title: "React Roadmap",
    description: "React roadmap from a beginner level to an advanced level",
    img: require("./images/pic4.webp"),
    link: "https://abelwanyonyi.hashnode.dev",
  },
];
export const projectData = [
  {
    id: 1,
    title: "liqour-mart",
    description: "website for buying liqour with firebase",
    img: require("./images/pic2.webp"),
    link: "https://liqour-mart.web.app",
  },
  {
    id: 2,
    title: "Nganya",
    description: "website for booking vans for roadtrips",
    img: require("./images/pic3.webp"),
    link: "https://nganya.netlify.app",
  },
  {
    id: 3,
    title: "sokomoto",
    description: "web app which allows designers to showcase the designs",
    img: require("./images/pic7.webp"),
    link: "https://exercise-tracker-simple.herokuapp.com",
  },

  {
    id: 4,
    title: "exercise tracker mern",
    description: "website for keeping track of your workouts",
    img: require("./images/pic5.webp"),
    link: "https://exercise-tracker-simple.herokuapp.com",
  },
  {
    id: 5,
    title: "Uradi nation",
    description: "Know whats happening around the school with uradi nation",
    img: require("./images/pic6.webp"),
    link: "https://uradi-nation.netlify.app",
  },
];

export default articles;
